import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import './common/Styles.css';
import TopBar from './common/home/TopBar';
import Footer from './common/home/Footer';
import { styles } from './common/Styles';
import { CONST_BUSINESS_MAIL, CONST_SITE_LABEL, MESSAGES } from './common/Helper';
import DebugService from '../services/DebugService';
import ContactUsApiService from '../services/ContactUsApiService';

const Contact = () => {
    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        organization: '',
        message: '',
    });

    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        organization: '',
        message: '',
    });

    const [disable, setDisable] = useState(false)
    const [showSuccessMessage, setShowSuccessMessage] = useState(false)

    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...errors };

        const keys = [];
        for (const key in formValues) {
            keys.push(key);
            for (const value of keys) {
                if (value !== 'phoneNumber') {
                    if (!formValues[value]) {
                        newErrors[value] = getErrorMessage(value);
                        isValid = false;
                    } else {
                        newErrors[value] = '';
                    }
                }
            }

        }
        if (isValid) {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
                isValid = false
                newErrors['email'] = MESSAGES.EMAIL_VALID
            }
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleReset = (e) => {
        setFormValues({
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            organization: '',
            message: '',
        })

        setTimeout(() => {
            setShowSuccessMessage(false)
        }, 3000)
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            setDisable(true)
            // Add your form submission logic here
            console.log('Form is valid. Submitting...', formValues);
            const apiRequestBody = {
                "firstname": formValues.firstName,
                "lastname": formValues.lastName,
                "email": formValues.email,
                "organization": formValues.organization,
                "message": formValues.message,
                "phoneNumber": formValues.phoneNumber
            }

            ContactUsApiService.submit(apiRequestBody)
            .then(response => {
                DebugService.log('Contact Us saved response', response)

                if (response !== undefined && response['message'] !== undefined) {
                    handleReset()
                    setDisable(false)
                    setShowSuccessMessage(true)
                } else {
                    DebugService.error('Something went wrong while saving contact us details', response)
                }
                
            })
            .catch(err => {
                DebugService.error('Caught error while saving contact us details..', err)
            })

        } else {
            console.log('Form is not valid. Please fill out all required fields.');
        }
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormValues({
            ...formValues,
            [id]: value,
        });
    };

    /**
     * @description Get error message for requested field name (input id)
     * @param {*} fieldName 
     * @returns 
     */
    const getErrorMessage = (fieldName) => {
        switch (fieldName) {
            case 'firstName': return MESSAGES.FNAME_REQ
            case 'lastName': return MESSAGES.LNAME_REQ
            case 'email': return MESSAGES.EMAIL_REQ
            case 'organization': return MESSAGES.ORGANIZATION_REQ
            case 'message': return MESSAGES.MESSAGE_REQ
            default: return 'Field is required'
        }
    }

    useEffect(() => {
        document.title = `${CONST_SITE_LABEL} | Contact Us`
    },[])

    return (

        <div style={{ backgroundImage: 'url("orange-img.jpg")' }} sx={{ width: "100%" }}>
            <TopBar />
            <div className='contact-page'>
                <div className="contact-page-container">
                    <div style={{
                        padding: '2vw'
                    }} >
                        <Typography variant='body1' style={{ marginTop: "2vw" }}>
                            Use the contact form to get in touch or email us at
                            &nbsp;<span title='Click to mail us' style={{
                                fontStyle: 'italic',
                                fontWeight: '600',
                                color: '#900C3F'
                            }}>
                                <a href={`mailto:${CONST_BUSINESS_MAIL}`} style={{
                                    textDecoration: 'none',
                                    color: 'inherit'
                                }}>{CONST_BUSINESS_MAIL}</a>
                            </span>.
                            We'll get back to you asap.
                        </Typography>
                        <br />
                        <Typography variant='body1' style={{ marginTop: "2vw" }}>
                            Want to know more about our platform?
                        </Typography>
                        {/* <div>
                            <Button sx={styles.button1} style={{ marginTop: "30px" }} variant="outlined"  >
                                Book a demo < ArrowForwardIcon fontSize='small' />
                            </Button>
                        </div> */}
                    </div>
                </div>
                <Box
                    className="Contact-form"
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{
                        '& > :not(style)': { m: 2, width: '100%', maxWidth: '400px' },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <div className='textfield1'>
                        <TextField
                            error={Boolean(errors.firstName)}
                            helperText={errors.firstName}
                            sx={{ margin: "10px 0px" }}
                            id="firstName"
                            name="firstName"
                            label="First Name"
                            variant="standard"
                            fullWidth
                            required
                            value={formValues.firstName}
                            onChange={handleChange}
                            inputProps={{
                                maxLength: 10
                            }}
                        />
                        <TextField
                            sx={{ margin: "10px 0px" }}
                            id="lastName"
                            name="lastName"
                            label="Last Name"
                            variant="standard"
                            fullWidth
                            required
                            value={formValues.lastName}
                            onChange={handleChange}
                            error={Boolean(errors.lastName)}
                            helperText={errors.lastName}
                            inputProps={{
                                maxLength: 10
                            }}
                        />
                    </div>
                    <TextField
                        sx={{ margin: "10px 0px" }}
                        id="email"
                        name='email'
                        label="Email"
                        variant="standard"
                        type="email"
                        fullWidth
                        required
                        value={formValues.email}
                        onChange={handleChange}
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                        inputProps={{
                            maxLength: 30
                        }}
                    />
                    <TextField
                        sx={{ margin: "10px 0px" }}
                        id="phoneNumber"
                        name='phoneNumber'
                        label="Phone Number"
                        variant="standard"
                        type="tel"
                        fullWidth
                        value={formValues.phoneNumber}
                        onChange={handleChange}
                        error={Boolean(errors.phoneNumber)}
                        helperText={errors.phoneNumber}
                        inputProps={{
                            maxLength: 14
                        }}
                    />
                    <TextField
                        sx={{ margin: "10px 0px" }}
                        id="organization"
                        name='organization'
                        label="Organization"
                        variant="standard"
                        fullWidth
                        required
                        value={formValues.organization}
                        onChange={handleChange}
                        error={Boolean(errors.organization)}
                        helperText={errors.organization}
                        inputProps={{
                            maxLength: 20
                        }}
                    />
                    <TextField
                        sx={{ margin: "10px 0px" }}
                        id="message"
                        name='message'
                        label="Message"
                        variant="standard"
                        fullWidth
                        required
                        multiline
                        minRows={2}//Set the minimum number of rows
                        maxRows={4}
                        value={formValues.message}
                        onChange={handleChange}
                        error={Boolean(errors.message)}
                        helperText={errors.message}
                        inputProps={{
                            maxLength: 1000
                        }}
                    />

                    {showSuccessMessage ? (
                        <Typography variant='body1' style={{ marginTop: "50px", fontSize: "1.55vw", textAlign: 'center', color: '#097969', fontWeight: 600 }}>
                            {MESSAGES.CONTACT_US_SAVE_SUCCESS}
                        </Typography>
                    ):(
                        <Button sx={styles.button1} style={{ marginTop: "50px" }} type="submit" variant="outlined" disabled={disable} >
                            Submit
                        </Button>
                    )}
                    

                </Box>

            </div>
            <Footer />
        </div>



    );
};

export default Contact;
